import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../config";
import { message } from "antd";
import { setError } from "./errorSlice";
import { createSafeThunk } from "../hooks/createSafeThunk";

/* export const fetchAllStudents = createSafeThunk({
  typePrefix: "students/fetchAllStudents",
  source: "students",
  validationFn: (batchId) => {
    if (!batchId) return "Missing student unique identification.";
    const token = localStorage.getItem("token");
    if (!token) return "Session expired. Please log in again.";
    return null;
  },
  apiCallFn: async (batchId) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_BASE_URL}/api/Student/statistics`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await response.json();
  },
  onError: (error, dispatch) => {
    message.error(error.message);
    dispatch(setError(error.message));
  },
}); */
export const fetchAllStudents = createAsyncThunk(
  "students/fetchAllStudents",
  async (batchId, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(`${API_BASE_URL}/api/Student/statistics`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        if (response.status === "404")
          throw new Error("There is no student in this batch");
        else throw new Error("Failed to fetch fee structures of the batch");
      }
      return response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);
// Async thunks
export const fetchStudentsByBatch = createAsyncThunk(
  "students/fetchStudentsByBatch",
  async (batchId, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/Student/get-all-students-in-batch/${batchId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        if (response.status === "404")
          throw new Error("There is no student in this batch");
        else throw new Error("Failed to fetch fee structures of the batch");
      }
      return response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const fetchStudentsByBatchAndSection = createAsyncThunk(
  "students/fetchStudentsByBatchAndSection",
  async (bsid, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/StudentBatchSection/Section/${bsid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        if (response.status === "404")
          throw new Error("There is no student in this batch");
        else throw new Error("Failed to fetch fee structures of the batch");
      }
      return response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const fetchStudentsByBatchWithOutSection = createAsyncThunk(
  "students/fetchStudentsByBatchWithOutSection",
  async (bsid, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      console.log("token", token);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/StudentBatchSection/Unassigned`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        if (response.status === "404")
          throw new Error("There is no student in this batch");
        else throw new Error("Failed to fetch fee structures of the batch");
      }
      return response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const createFeeStructure = createAsyncThunk(
  "feeStructure/create",
  async (feeData, { rejectWithValue, dispatch }) => {
    //    console.log("JSON.stringify(feeData)", JSON.stringify(feeData));
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(`${API_BASE_URL}/api/FeeStructure`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(feeData),
      });
      if (!response.ok) {
        throw new Error("Failed to create fee structure");
      }
      return response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const updateFeeStructure = createAsyncThunk(
  "feeStructure/update",
  async ({ editingFeeId, feeData }, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/FeeStructure/${editingFeeId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(feeData),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to update fee structure");
      }
      return response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);

export const deleteFeeStructure = createAsyncThunk(
  "feeStructure/delete",
  async (feeId, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/FeeStructure/${feeId}`,
        {
          method: "DELETE",
        }
      );
      if (!response.ok) {
        throw new Error("Failed to delete fee structure");
      }
      return feeId;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);


export const fetchStudentById = createAsyncThunk(
  "students/fetchStudentById",
  async (studentId, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const response = await fetch(`${API_BASE_URL}/api/Student/find/${studentId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 404)
          throw new Error("Student not found.");
        else throw new Error("Failed to fetch student by ID.");
      }

      return await response.json();
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    }
  }
);


export const fetchStudentCategories = createAsyncThunk(
  "feeStructure/fetchStudentCategories",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      if (!storedUser) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }

      const { token } = JSON.parse(storedUser);
      if (!token) {
        dispatch(setError("Session expired. Please log in again."));
        return rejectWithValue("Session expired. Please log in again.");
      }
      const response = await fetch(`${API_BASE_URL}/api/Enum/StudentCategory`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch student categories");
      }
      const data = await response.json();
      return data;
    } catch (error) {
      dispatch(setError("Error fetching student categories:", error.message));
      return rejectWithValue(
        "Error fetching student categories:",
        error.message
      );
    }
  }
);
const initialState = {
  batch_students: [],
  all_students: [],
  batch_section_students: [],
  studentCategories: [],
  selectedStudent: null,
  loading: false,
    byId: {}, // ✅ add this
  error: null,
  selectedFeeStructure: null,
};

const studentsSlice = createSlice({
  name: "students",
  initialState,
  reducers: {
    setSelectedFeeStructure: (state, action) => {
      state.selectedFeeStructure = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Fee Structures
      .addCase(fetchStudentsByBatch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentsByBatch.fulfilled, (state, action) => {
        state.loading = false;
        state.batch_students = action.payload.data || [];
        //       console.log(" state.batch_students", state.batch_students);
      })
      .addCase(fetchStudentsByBatch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      //fetchAllStudents
      .addCase(fetchAllStudents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllStudents.fulfilled, (state, action) => {
        state.loading = false;
        state.all_students = action.payload || [];
        //        console.log(" state.all_students", state.all_students);
      })
      .addCase(fetchAllStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchStudentsByBatchAndSection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentsByBatchAndSection.fulfilled, (state, action) => {
        state.loading = false;
        //        console.log(" action.payload", action.payload);
        state.batch_section_students = action.payload || [];
        //        console.log(" state.batch_students", state.batch_section_students);
      })
      .addCase(fetchStudentsByBatchAndSection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.batch_section_students = [];
      })
      .addCase(fetchStudentsByBatchWithOutSection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchStudentsByBatchWithOutSection.fulfilled,
        (state, action) => {
          state.loading = false;
          //          console.log(" action.payload", action.payload);
          state.batch_section_students = action.payload || [];
          //          console.log(" state.batch_students", state.batch_section_students);
        }
      )
      .addCase(fetchStudentsByBatchWithOutSection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.batch_section_students = [];
      })

      .addCase(fetchStudentById.pending, (state) => {
  state.loading = true;
  state.error = null;
})
.addCase(fetchStudentById.fulfilled, (state, action) => {
  state.loading = false;
  const student = action.payload;
  if (student?.studentId) {
    state.byId[student.studentId] = student; // ✅ store by ID
  }
})

.addCase(fetchStudentById.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload || action.error.message;
  state.selectedStudent = null;
})

      //
      .addCase(fetchStudentCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentCategories.fulfilled, (state, action) => {
        state.loading = false;

        const categoriesArray = Object.entries(
          action.payload.StudentCategory
        ).map(([value, name]) => ({
          value: parseInt(value),
          name: name,
        }));
        state.studentCategories = categoriesArray;
      })
      .addCase(fetchStudentCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearError } = studentsSlice.actions;
export default studentsSlice.reducer;
